import raf from "raf"
import domready from "domready"
import perfNow from "performance-now"
// noinspection ES6UnusedImports
import STYLE from "./style.css"
import {
    Color,
    CubeCamera,
    DirectionalLight,
    Matrix4,
    PerspectiveCamera,
    Quaternion,
    Scene,
    Sprite,
    SpriteMaterial,
    sRGBEncoding,
    Vector3,
    WebGLCubeRenderTarget,
    WebGLRenderer
} from "three"

import { Sky } from "three/examples/jsm/objects/Sky.js";

import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import loadTexture from "./loadTexture";
import positionFromMatrix from "./positionFromMatrix";
import { easeInCubic } from "./easing";


const SKY_EFFECT = true;

let container, stats, envMap;
let camera, scene, renderer, light;
let controls;


const skyParameters = {
    distance: 1000,
    inclination: 0.42,
    azimuth: 0.1
};


function updateSun()
{

    if (!sky)
    {
        return;
    }

    const theta = Math.PI * (skyParameters.inclination - 0.5);
    const phi = 2 * Math.PI * (skyParameters.azimuth - 0.5);

    light.position.x = skyParameters.distance * Math.cos(phi);
    light.position.y = skyParameters.distance * Math.sin(phi) * Math.sin(theta);
    light.position.z = skyParameters.distance * Math.sin(phi) * Math.cos(theta);

    sky.material.uniforms["sunPosition"].value = light.position.copy(light.position);

    cubeCamera.update(renderer, sky);

}


let cubeCamera, sky;



//const CAMERA_MATRIX = [0.9998967436652689,1.0842021724855044e-19,-0.014370177716070404,0,0.0017518645549679747,0.9925411913624905,0.12189714688748401,0,0.014262993310399232,-0.12190973483987161,0.9924387051970008,0,1.5116542598268052,-12.939086754479849,105.26297989017192,1];
const CAMERA_MATRIX = [0.9998969005233186,0,-0.014359259168234693,0,0.0017516986594874983,0.9925312212927574,0.12197830262351417,0,0.014252013039107204,-0.12199087981938345,0.9924288918432522,0,7.803637786641486,-66.79566155124819,543.4008220236575,1];

const startPosition = positionFromMatrix(CAMERA_MATRIX);
const target = positionFromMatrix(CAMERA_MATRIX);

const matrix = new Matrix4()
matrix.fromArray([0.9998969005233186,1.0842021724855043e-19,-0.01435925916823469,0,0.0017516986594874981,0.9925312212927574,0.12197830262351418,0,0.014252013039107201,-0.12199087981938346,0.9924288918432522,0,0.02911857243532892,-0.249242002566449,2.027651286506347,1]);

const targetPosition = new Vector3();
matrix.decompose(targetPosition,new Quaternion(), new Vector3());

function init()
{

    container = document.getElementById("container");

    //

    renderer = new WebGLRenderer();
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.outputEncoding = sRGBEncoding
    container.appendChild(renderer.domElement);

    //

    scene = new Scene();

    camera = new PerspectiveCamera(55, window.innerWidth / window.innerHeight, 1, 20000);

    //camera.position.set(25, 25, 100);

    camera.matrix.fromArray(CAMERA_MATRIX);
    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);

    //

    light = new DirectionalLight("#fff8d5", 0.8);
    scene.add(light);



    cubeCamera = new CubeCamera(0.2, 1, new WebGLCubeRenderTarget(512));
    // cubeCamera.renderTarget.texture.generateMipmaps = true;
    // cubeCamera.renderTarget.texture.minFilter = LinearMipmapLinearFilter;

    scene.background = cubeCamera.renderTarget;

    // Skybox
    if (SKY_EFFECT)
    {
        sky = new Sky();


        // uniforms["turbidity"].value = 5;
        // uniforms["rayleigh"].value = 1.2;
        // uniforms["luminance"].value = 1;
        // uniforms["mieCoefficient"].value = 0.05;
        // uniforms["mieDirectionalG"].value = 0.9;

        envMap = cubeCamera.renderTarget.texture

        updateSun();
    }
    else
    {
        envMap = null;
    }

    if (ORBIT_CONTROLS)
    {
        controls = new OrbitControls(camera, renderer.domElement);
        //controls.maxPolarAngle = Math.PI * 0.45;
        controls.maxPolarAngle = Math.PI;
        controls.target.set(0, 0, 0);
        controls.minDistance = 0.0;
        controls.maxDistance = 1000.0;
        controls.enableDamping = true;
        controls.dampingFactor = 0.02;
        controls.update();

    }


    console.log("CAMERA", JSON.stringify(camera.matrix.toArray()));

    // stats = new Stats();
    // container.appendChild( stats.dom );

    // GUI

    //const gui = new GUI();

    // const folder = gui.addFolder( "Sky" );
    // folder.add( skyParameters, "inclination", 0, 0.5, 0.0001 ).onChange( updateSun );
    // folder.add( skyParameters, "azimuth", 0, 1, 0.0001 ).onChange( updateSun );
    // folder.open();
    //
    // const uniforms = water.material.uniforms;
    //
    // const folder = gui.addFolder( "Water" );
    // folder.add( uniforms.distortionScale, "value", 0, 8, 0.1 ).name( "distortionScale" );
    // folder.add( uniforms.size, "value", 0.1, 10, 0.1 ).name( "size" );
    // folder.add( uniforms.alpha, "value", 0.9, 1, .001 ).name( "alpha" );
    // folder.open();

    window.addEventListener("resize", onWindowResize, false);
    window.addEventListener("dblclick", ev =>{

        console.log("CAMERA", JSON.stringify(camera.matrix.toArray()))

    }, false);

}


function onWindowResize()
{

    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize(window.innerWidth, window.innerHeight);

}


let startTime = 0;
let prevTime = 0;

const RUNTIME = 20 * 1000;


function adjustPositions(ring)
{
    const { angle : startAngle, spheres, sprites, radius } = ring;

    const step = TAU / spheres;


    let angle = startAngle;
    for (let j=0; j < spheres; j++)
    {
        tmpY.copy(yVector).multiplyScalar(Math.sin(angle) * radius);
        sprites[j].position.copy(xVector).multiplyScalar(Math.cos(angle) * radius).add(tmpY);

        angle += step;
    }

}


function rotateRings(delta)
{
    const newRotations = [];
    for (let i = 0; i < rotations.length; i++)
    {
        const rotation = rotations[i];

        const { ring, dir, angle : targetAngle } = rotation;

        if (dir > 0)
        {
            let { angle } = ring;

            if (angle > targetAngle)
            {
                ring.angle = targetAngle;
                ring.rotating = false;
            }
            else
            {
                ring.angle += rotation.speed;
            }
        }
        else
        {
            let { angle } = ring;

            if (angle < targetAngle)
            {
                ring.angle = targetAngle;
                ring.rotating = false;
            }
            else
            {
                ring.angle -= rotation.speed;
            }
        }

        adjustPositions(ring);

        if (ring.rotating)
        {
            newRotations.push(rotation);
        }
    }

    rotations = newRotations;
}


function mainLoop()
{
    const now = perfNow();

    const time = ((now - startTime) % RUNTIME)/RUNTIME;


    camera.position.copy(targetPosition).sub(startPosition).multiplyScalar(easeInCubic(time)).add(startPosition);

    const delta = now - prevTime;

    rotateRings(delta);

    render();
    updateSun();

    if (controls)
    {
        controls.update()
    }

    prevTime = now;

    if (Math.random() < 0.2)
    {
        addRandomRotation();
    }

    raf(mainLoop);

}

function render()
{
    renderer.render(scene, camera);
}

const NUM_SPHERES = 110;

const ORBIT_CONTROLS = true;

// scale of each sphere
const SPHERE_SCALE = 12;

// size of the random sphere spawn area
const SPHERE_AREA = 120;

const TAU = 2 * Math.PI;
const PHI = (1+Math.sqrt(5))/2;

function addSprite(mat, x, y, z)
{
    const sprite = new Sprite(mat);
    scene.add(sprite);

    sprite.position.set(
        x,
        y,
        z
    );
    sprite.scale.set(SPHERE_SCALE, SPHERE_SCALE, SPHERE_SCALE);

    return sprite;
}

const NUM_RINGS = 50;
const DISTANCE = SPHERE_SCALE * 1.14589803375031543

const tmp = new Vector3();
const tmpY = new Vector3();


const rings = [];

let rotations = [];

let xVector,yVector;

const ROTATION_SPEED = 0.13;

function addRandomRotation()
{
    const ring = rings[(Math.random() * rings.length)|0];

    if (ring.rotating)
    {
        return;
    }

    ring.rotating = true;


    const sphereStep = TAU / ring.spheres;


    let randomAngle = ((0.2 + Math.random() * ring.spheres * 0.3)|0) * sphereStep;
    let dir = 1;
    if (randomAngle > TAU/2)
    {
        randomAngle = -(TAU - randomAngle);
        dir = -1;
    }
    const targetAngle = ring.angle + randomAngle;
    rotations.push({
        ring,
        angle: targetAngle,
        speed: ROTATION_SPEED * Math.abs(ring.angle - targetAngle),
        dir
    })

}


domready(() => {

    Promise.all([
        loadTexture("assets/transparent-dot.png")
    ])
    .then(([ tDot ]) =>
    {

        const mat = [];

        let hue = 0;
        let isOdd = false;
        for (let i=0; i < NUM_RINGS + 1; i++)
        {
            const color = new Color(0,0,0);

            if (isOdd)
            {
                color.setHSL(hue + 0.5, 1, 0.2);
            }
            else
            {
                color.setHSL(hue, 1, 0.2);
            }

            mat[i] = new SpriteMaterial({
                map: tDot,
                color: color,
                transparent: true,
            });

            if (isOdd)
            {
                hue += PHI;
            }
            isOdd = !isOdd;
        }
        init();

        const half = SPHERE_AREA/2;

        // we orient the camera to a pretty section of the sky background and then create the scene perpendicular to
        // the eye vector
        xVector = new Vector3(1, 0, 0);
        yVector = new Vector3(0, 1, 0);
        const eyeVector = new Vector3(0, 0, -1);
        xVector.applyEuler(camera.rotation);
        yVector.applyEuler(camera.rotation);
        eyeVector.applyEuler(camera.rotation);

        //console.log("EYE VECTOR: ", {xVector,yVector,eyeVector});


        addSprite(mat[0], 0, 0, 0);

        let radius = DISTANCE;
        for (let i=0; i < NUM_RINGS; i++)
        {
            const spheres = Math.floor(TAU * radius / DISTANCE);
            const step = TAU / spheres;

            let angle = Math.random() * TAU;

            const sprites = [];

            rings.push({
                spheres,
                angle,
                sprites,
                radius,
                rotating: false
            })


            for (let j=0; j < spheres; j++)
            {
                tmp.copy(xVector).multiplyScalar(Math.cos(angle) * radius);
                tmpY.copy(yVector).multiplyScalar(Math.sin(angle) * radius);

                tmp.add(tmpY);

                sprites.push(
                    addSprite(mat[i + 1], tmp.x, tmp.y, tmp.z)
                );

                angle += step;
            }

            radius += DISTANCE;
        }

        //console.log("RINGS", rings);

        // for (let i=0; i < NUM_SPHERES; i++)
        // {
        //     for (let j = 0; j < tDot.length; j++)
        //     {
        //         const tDotElement = tDot[j];
        //
        //     }
        //
        //     const x = Math.random() * SPHERE_AREA - half;
        //     const y = Math.random() * SPHERE_AREA - half;
        //     const z = Math.random() * SPHERE_AREA - half;
        //
        //     const d =Math.sqrt(x * x + y * y + z * z)/max;
        //     const sprite = new Sprite(mat[ d*16|0]);
        //     scene.add(sprite);
        //
        //     sprite.position.set(
        //         x,
        //         y,
        //         z
        //     );
        //     sprite.scale.set(SPHERE_SCALE, SPHERE_SCALE, SPHERE_SCALE);
        // }

        startTime = prevTime = perfNow();
        raf(mainLoop);

    })

})

